/**
=========================================================
* Material Kit 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Kit 2 PRO React base styles
import typography from "../../base/typography";
import colors from "../../base/colors";

// Material Kit 2 PRO React helper functions
import pxToRem from "../../functions/pxToRem";
import rgba from "../../functions/rgba";
import { grey, pink } from "@mui/material/colors";

const { size, fontWeightRegular,fontWeightBold } = typography;
const { white,black } = colors;

export default {
  styleOverrides: {
    label: {
      marginTop: `${pxToRem(8)} !important`,
      marginLeft: `${pxToRem(8)} !important`,
      fontWeight: fontWeightRegular,
      fontSize: size.sm,
      color:`${colors.grey[500]} !important`,
      // textTransform: "uppercase",

      "&.Mui-active": {
        fontWeight: `${500} !important`,
        // color: `${rgba(white.main, 0.8)} !important`,
      color: `${colors.JTCElectricBlue} !important`,
      
      },

      "&.Mui-completed": {
        // fontWeight: `${fontWeightBold} !important`,
        color: `${colors.grey[500]} !important`,
        '&$Mui-completed audittrail': {
          color: colors.grey.focus,
        },
      },
      "&.completed": {
        background: colors.JTCElectricBlue,
        fill: colors.JTCElectricBlue,
        stroke: colors.JTCElectricBlue,
        borderColor: colors.JTCElectricBlue,
      },


      '&$Mui-completed audittrail': {
        color: colors.black.focus,
      },
      '&.alternativeLabel': {
        textAlign: 'center',
        marginTop: 16,
        color: `${rgba(black.main, 0.8)} !important`,
      },
   
    },
  },
};
